"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _moment = require("moment/moment");

var _moment2 = _interopRequireDefault(_moment);

var _ramda = require("ramda");

var _card_component = require("./global_components/card_component.js");

var _card_component2 = _interopRequireDefault(_card_component);

var _date_range_dropdown = require("./global_components/date_range_dropdown");

var _date_range_dropdown2 = _interopRequireDefault(_date_range_dropdown);

var _click_or_escape_outside = require("./click_or_escape_outside");

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _daily_performance_table = require("./daily_performance_table");

var _daily_performance_table2 = _interopRequireDefault(_daily_performance_table);

var _functional_utility = require("common-utilities/src/functional_utility");

var _collection_utility = require("common-utilities/src/collection_utility");

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _date_formatter = require("../../../packages/common-utilities/src/date_formatter.js");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _number_utility = require("../../../packages/common-utilities/src/number_utility.js");

var _number_utility2 = _interopRequireDefault(_number_utility);

var _single_date_picker_wrapper = require("./global_components/single_date_picker_wrapper");

var _single_date_picker_wrapper2 = _interopRequireDefault(_single_date_picker_wrapper);

var _daily_performance_chart = require("./charts/daily_performance_chart.js");

var _daily_performance_chart2 = _interopRequireDefault(_daily_performance_chart);

var _button = require("./global_components/button");

var _button2 = _interopRequireDefault(_button);

var _sanitize_utility = require("common-utilities/src/sanitize_utility");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _chart_utility = require("../../../packages/common-utilities/src/chart_utility");

var _legendCircle = require("./charts/legendCircle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setTooltipWrapper = function setTooltipWrapper(text) {
  return _react2.default.createElement(
    "span",
    { "data-testid": "tooltip-error",
      id: "tooltip-error",
      className: "caption font-light font-extreme-red" },
    text
  );
};
var getDateFromObject = function getDateFromObject(data) {
  var pathToDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "date";
  return (0, _ramda.path)([pathToDate], data);
};
var mapIndexed = (0, _ramda.addIndex)(_ramda.map);
var subtractYears = function subtractYears(date, numberOfYears) {
  return _moment2.default.utc(date).endOf('date').subtract(numberOfYears, "years").format(_date_formatter2.default.edpiDateFormat);
};

var DailyPerformanceChartParent = function (_React$Component) {
  _inherits(DailyPerformanceChartParent, _React$Component);

  function DailyPerformanceChartParent(props) {
    _classCallCheck(this, DailyPerformanceChartParent);

    var _this = _possibleConstructorReturn(this, (DailyPerformanceChartParent.__proto__ || Object.getPrototypeOf(DailyPerformanceChartParent)).call(this, props));

    _this.renderToolTipErrorMessage = function (elementId, errorKey) {
      var additionalProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var tooltipMessage = null;
      var values = {
        startDate: _date_formatter2.default.getLocalFormattedDate(getDateFromObject(_this.props.dailyPerformanceData[0])),
        endDate: _date_formatter2.default.getLocalFormattedDate(getDateFromObject((0, _ramda.last)(_this.props.dailyPerformanceData)))
      };
      if (errorKey === 'pdp-historical-chart-error-message-out-of-range') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[4], errorKey, values);
      } else if (errorKey === 'pdp-historical-chart-error-message-prior-to-to-date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[0], errorKey, values);
      } else if (errorKey === 'pdp-historical-chart-error-message-from-date-same-as-to-date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[2], errorKey);
      } else if (errorKey === 'pdp-historical-chart-error-message-prior-to-from-Date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[1], errorKey, values);
      } else if (errorKey === 'pdp-historical-chart-error-message-to-date-same-as-from-date') {
        tooltipMessage = _string_utility2.default.renderFormattedLabel(_this.errorMessages[3], errorKey);
      }
      tooltipMessage = setTooltipWrapper(tooltipMessage);
      var el = document.getElementById(elementId);
      var elHeight = el.offsetHeight;
      var elWidth = el.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var offsetArrowHeight = 4;
      var elPadding = 10;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      var toolTipWidth = el.offsetWidth;

      var elOffset = (0, _ramda.mergeDeepRight)({
        top: elRect.top + docTop + arrowHeight + elHeight - offsetArrowHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - elPadding + (elRect.right - elRect.left) / 8,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipWidth,
        showCrossIcon: false
      }, additionalProps);

      _this.setState({
        error: "extreme",
        errorId: elementId
      });
      elementId === _this.props.id + '-from-date' ? _this.refs.from_dropdown_ref.handleOpen() : _this.refs.to_dropdown_ref.handleOpen();
      _this.props.tooltip.openTooltip(elOffset, null, tooltipMessage, false);
    };

    _this.injectComponent = (0, _reactIntl.injectIntl)(_daily_performance_chart2.default);
    _this.renderDateRangeDropdown = _this.renderDateRangeDropdown.bind(_this);
    _this.renderCustomDatePickers = _this.renderCustomDatePickers.bind(_this);
    _this.onChangeFromDate = _this.onChangeFromDate.bind(_this);
    _this.onChangeToDate = _this.onChangeToDate.bind(_this);
    _this.setDateFilter = _this.setDateFilter.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    _this.dateRangeItems = _this.dateRangeItems.bind(_this);

    var selectedDateOption = "Since Inception";
    var selectedDateOptionTranslateKey = "since-inception";
    var dailyPerformanceData = _collection_utility.CollectionUtility.clone(_this.props.dailyPerformanceData);
    var fromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject(dailyPerformanceData[0]), "YYYY-MM-DD"));
    var toDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(dailyPerformanceData)), "YYYY-MM-DD"));
    _this.minDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject(dailyPerformanceData[0]), "YYYY-MM-DD"));
    _this.maxDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(dailyPerformanceData)), "YYYY-MM-DD"));
    var selectedDateOptionValue = '0';

    _this['dropdown-label-dateRange'] = { 'text': '' };
    _this['dropdown-toggle-from'] = { 'value': '' };
    _this['dropdown-toggle-to'] = { 'value': '' };

    _this.errorMessages = ["From Date has to be less than to date.", "To Date cannot be less than from date", "From Date cannot be same as To date", "To Date cannot be same as From date", _this.defaultOutOfRangeErrorMessage()];

    if (!(0, _ramda.isNil)((_this.props.visibleData || {}).visibleDataPoints) && _collection_utility.CollectionUtility.includes((_this.props.visibleData || {}).visibleDataPoints, 'DAILY_PERFORMANCE_CARD__DEFAULT_FIVE_YEAR_OPTION')) {
      selectedDateOption = "Last 5 years";
      dailyPerformanceData = _this.getFilteredData(60);
      selectedDateOptionValue = '60';
      selectedDateOptionTranslateKey = "dropdown-last-5-years";
      fromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(subtractYears(getDateFromObject((0, _ramda.last)(_this.props.dailyPerformanceData)), 5), "YYYY-MM-DD"));
    }

    _this.state = {
      dailyPerformanceData: dailyPerformanceData,
      fromDate: fromDate,
      toDate: toDate,
      count: 5,
      selectedDateOption: selectedDateOption,
      selectedDateOptionTranslateKey: selectedDateOptionTranslateKey,
      validFromDate: fromDate,
      validToDate: toDate,
      selectedDateOptionValue: selectedDateOptionValue
    };
    return _this;
  }

  _createClass(DailyPerformanceChartParent, [{
    key: "setRef",
    value: function setRef(refId) {
      var _this2 = this;

      return function (el) {
        return _this2[refId] = el;
      };
    }
  }, {
    key: "defaultOutOfRangeErrorMessage",
    value: function defaultOutOfRangeErrorMessage() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.dailyPerformanceData)) {
        return "Please enter a date within the date range";
      }
      return "Please enter a date within the date range " + getDateFromObject(this.props.dailyPerformanceData[0]) + " - " + getDateFromObject((0, _ramda.last)(this.props.dailyPerformanceData)) + ".";
    }
  }, {
    key: "getPlotPoints",
    value: function getPlotPoints(performanceData) {
      var plotPoints = [];
      var runningValue = 1;
      for (var i = 0; i < performanceData.length; i++) {
        var value = performanceData[i].cumulativeNoLoadPercentage || 0;
        runningValue *= 1 + value;
        var newPlotPoint = {
          date: performanceData[i].date,
          cumulativeNoLoadPercentage: value * 100,
          cumulativeNoLoadPercentageInc: (runningValue - 1) * 100
        };
        plotPoints.push(newPlotPoint);
      }
      return plotPoints;
    }
  }, {
    key: "getYAxisTicks",
    value: function getYAxisTicks(plotPoints) {
      var min = Math.min.apply(null, plotPoints.map(function (a) {
        return a.cumulativeNoLoadPercentageInc;
      }));
      var max = Math.max.apply(null, plotPoints.map(function (a) {
        return a.cumulativeNoLoadPercentageInc;
      }));
      return _number_utility2.default.getPercentageTicks(min, max, 0, 6);
    }
  }, {
    key: "dateRangeItems",
    value: function dateRangeItems() {
      var _this3 = this;

      var dateRangeArray = this.getDateRangeArray();
      var count = this.state.count;
      var items = mapIndexed(function (dateRangeOption, index) {
        return _this3.generateDateRangeRow(dateRangeOption.value, dateRangeOption.displayValue, dateRangeOption.translationKey, index);
      }, dateRangeArray).slice(0, count);
      items.push(this.generateDateRangeRow("custom", "Custom Date Range", "dropdown-custom-date-range", dateRangeArray.length));
      return items;
    }
  }, {
    key: "getDateRangeArray",
    value: function getDateRangeArray() {
      var dateRangeArray = [];
      var yearMapArray = [{ years: 1, value: '12' }, { years: 3, value: '36' }, { years: 5, value: '60' }, { years: 10, value: '120' }];
      dateRangeArray.push({
        value: '0',
        displayValue: 'Since Inception',
        translationKey: 'since-inception'
      });
      this.addYearMapsToDateRangeArray(dateRangeArray, yearMapArray);
      return dateRangeArray;
    }
  }, {
    key: "addYearMapsToDateRangeArray",
    value: function addYearMapsToDateRangeArray(dateRangeArray, yearMapArray) {
      var index = void 0;
      for (index = 0; index < yearMapArray.length; index++) {
        if ((0, _moment2.default)(this.maxDate).diff((0, _moment2.default)(this.minDate), 'year') >= yearMapArray[index].years) {
          dateRangeArray.push({
            value: yearMapArray[index].value,
            displayValue: 'Last ' + yearMapArray[index].years + ' year' + (yearMapArray[index].years > 1 ? 's' : ''),
            translationKey: 'dropdown-last-' + yearMapArray[index].years + '-year' + (yearMapArray[index].years > 1 ? 's' : '')
          });
        }
      }
    }
  }, {
    key: "setCustomDateRangeDropdown",
    value: function setCustomDateRangeDropdown() {
      this['dropdown-label-dateRange'].text = 'Custom Date Range';
      this.setState({
        selectedDateOption: 'Custom Date Range',
        selectedDateOptionTranslateKey: 'dropdown-custom-date-range',
        selectedDateOptionValue: 'custom'
      });
    }
  }, {
    key: "generateDateRangeRow",
    value: function generateDateRangeRow(value, displayValue, translationKey) {
      return _react2.default.createElement(
        "div",
        { "data-option-value": value, "data-translation-key": translationKey, "data-display-value": displayValue,
          onClick: this.setDateFilter, className: "dropdown-list-item", role: "option" },
        _react2.default.createElement(
          "span",
          { className: "font-light caption", "data-option-value": value,
            "data-translation-key": translationKey, "data-display-value": displayValue },
          _string_utility2.default.renderFormattedLabel(displayValue, translationKey)
        )
      );
    }
  }, {
    key: "setDateFilter",
    value: function setDateFilter(event) {
      var _this4 = this;

      var filteredData = void 0;
      var dateOption = 0;
      var toDate = '';
      var fromDate = '';

      var target = (0, _ramda.isNil)(event.target.getAttribute('data-option-value')) ? event.target.parentNode : event.target;

      if (target.getAttribute('data-option-value') === 'custom') {
        this['dropdown-label-dateRange'].text = 'Custom Date Range';

        toDate = getDateFromObject((0, _ramda.last)(this.props.dailyPerformanceData));
        if (this.state.selectedDateOptionValue === '0') {
          fromDate = getDateFromObject(this.props.dailyPerformanceData[0]);
        } else {
          fromDate = _moment2.default.utc(toDate).endOf('day').subtract(Number(this.state.selectedDateOptionValue), 'months');
        }
        fromDate = _date_formatter2.default.getDateInSpecificFormat(fromDate, "YYYY-MM-DD");
        toDate = _date_formatter2.default.getDateInSpecificFormat(toDate, "YYYY-MM-DD");
        this.setState({
          selectedDateOption: target.getAttribute('data-display-value'),
          selectedDateOptionTranslateKey: target.getAttribute('data-translation-key'),
          toDate: (0, _moment2.default)(toDate),
          fromDate: (0, _moment2.default)(fromDate),
          selectedDateOptionValue: 'custom'
        }, function () {
          _this4.props.tooltip.closeTooltip();
        });
      } else {
        this['dropdown-label-dateRange'].text = target.getAttribute('data-display-value');
        dateOption = Number(target.getAttribute('data-option-value'));

        toDate = getDateFromObject((0, _ramda.last)(this.props.dailyPerformanceData));
        var numberOfYears = (0, _ramda.cond)([[(0, _ramda.equals)(0), (0, _ramda.always)(0)], [(0, _ramda.equals)(12), (0, _ramda.always)(1)], [(0, _ramda.equals)(36), (0, _ramda.always)(3)], [(0, _ramda.equals)(60), (0, _ramda.always)(5)], [(0, _ramda.equals)(120), (0, _ramda.always)(10)]])(dateOption);
        var performanceFromDate = numberOfYears === 0 ? getDateFromObject(this.props.dailyPerformanceData[0]) : subtractYears(toDate, numberOfYears);
        if (dateOption === 0) {
          fromDate = getDateFromObject(this.props.dailyPerformanceData[0]);
          filteredData = _collection_utility.CollectionUtility.clone(this.props.dailyPerformanceData);
        } else {
          fromDate = subtractYears(toDate, numberOfYears);
          filteredData = this.getFilteredData(dateOption);
        }
        fromDate = _date_formatter2.default.getDateInSpecificFormat(fromDate, "YYYY-MM-DD");
        toDate = _date_formatter2.default.getDateInSpecificFormat(toDate, "YYYY-MM-DD");

        this.setState({
          selectedDateOptionValue: dateOption.toString(),
          selectedDateOption: target.getAttribute('data-display-value'),
          selectedDateOptionTranslateKey: target.getAttribute('data-translation-key'),
          dailyPerformanceData: filteredData,
          toDate: (0, _moment2.default)(toDate),
          fromDate: (0, _moment2.default)(fromDate),
          performanceFromDate: performanceFromDate,
          performanceToDate: getDateFromObject((0, _ramda.last)(this.props.dailyPerformanceData)),
          error: 'moderate',
          errorId: null
        }, function () {
          _this4.props.tooltip.closeTooltip();
        });

        this['dropdown-toggle-from'].value = _date_formatter2.default.getDateInSpecificFormat(performanceFromDate, this.uiDateFormat(this.props.numberFormat));
        this['dropdown-toggle-to'].value = _date_formatter2.default.getDateInSpecificFormat(getDateFromObject((0, _ramda.last)(this.props.dailyPerformanceData)), this.uiDateFormat(this.props.numberFormat));
      }
    }
  }, {
    key: "uiDateFormat",
    value: function uiDateFormat(format) {
      return format === "european" ? "MM.YYYY" : "MM/YYYY";
    }
  }, {
    key: "getFilteredData",
    value: function getFilteredData(dateOption) {
      var latestMonthEnd = getDateFromObject((0, _ramda.last)(this.props.dailyPerformanceData));
      var filteredDate = _moment2.default.utc(latestMonthEnd).endOf('day').subtract(Number(dateOption), 'months');
      return _collection_utility.CollectionUtility.filter(this.props.dailyPerformanceData, function (performance) {
        return performance.epochDate >= filteredDate;
      });
    }
  }, {
    key: "onChangeFromDate",
    value: function onChangeFromDate(fromDate) {
      var validToDate = this.state.validToDate;

      var errorMessage = "";

      if ((0, _ramda.isNil)(fromDate) || fromDate.startOf('day').isBefore(this.minDate, "YYYY-MM-DD")) {
        this.handleOutOfRangeDate(this.props.id + "-from-date");
        return false;
      }

      if (fromDate.isAfter(validToDate)) {
        errorMessage = "pdp-historical-chart-error-message-prior-to-to-date";
      } else if (fromDate.isSame(validToDate)) {
        errorMessage = "pdp-historical-chart-error-message-from-date-same-as-to-date";
      }
      this.validateDate(errorMessage, fromDate, validToDate, this.props.id + "-from-date");
    }
  }, {
    key: "onChangeToDate",
    value: function onChangeToDate(toDate) {
      var validFromDate = this.state.validFromDate;

      var errorMessage = "";
      if ((0, _ramda.isNil)(toDate) || toDate.startOf('day').isAfter(this.maxDate)) {
        this.handleOutOfRangeDate(this.props.id + "-to-date");
        return false;
      }

      if (toDate.isBefore(validFromDate, "YYYY-MM-DD")) {
        errorMessage = "pdp-historical-chart-error-message-prior-to-from-Date";
      } else if (toDate.isSame(validFromDate, "day") && toDate.isSame(validFromDate, "month") && toDate.isSame(validFromDate, "year")) {
        errorMessage = "pdp-historical-chart-error-message-to-date-same-as-from-date";
      }
      this.validateDate(errorMessage, validFromDate, toDate, this.props.id + "-to-date");
    }
  }, {
    key: "handleOutOfRangeDate",
    value: function handleOutOfRangeDate(label) {
      var _this5 = this;

      this.setState({
        fromDate: label === this.props.id + '-from-date' ? null : this.state.fromDate,
        toDate: label === this.props.id + '-to-date' ? null : this.state.toDate,
        errorMessage: "pdp-historical-chart-error-message-out-of-range"
      }, function () {
        return _this5.renderToolTipErrorMessage(label, "pdp-historical-chart-error-message-out-of-range", {
          toolTipWidth: "254px",
          toolTipContentWidth: "100%"
        });
      });
    }
  }, {
    key: "validateDate",
    value: function validateDate(errorMessage, fromDate, toDate, label) {
      var _this6 = this;

      var filteredData = void 0;
      var validDateRange = (0, _ramda.isEmpty)(errorMessage);

      if (validDateRange) {
        filteredData = this.setFilteredData(fromDate, toDate);
        this.setState({
          fromDate: fromDate,
          validFromDate: fromDate,
          toDate: toDate,
          validToDate: toDate,
          dailyPerformanceData: filteredData,
          errorMessage: errorMessage
        }, this.props.tooltip.closeTooltip());
      } else {
        this.setState({
          errorMessage: errorMessage
        }, function () {
          return _this6.renderToolTipErrorMessage(label, errorMessage, {
            toolTipWidth: "254px",
            toolTipContentWidth: "100%"
          });
        });
      }
    }
  }, {
    key: "setFilteredData",
    value: function setFilteredData(fromDate, toDate) {
      var normalizedFromDate = _moment2.default.utc((0, _moment2.default)(fromDate.toDate()).startOf('date'));
      var normalizedToDate = _moment2.default.utc((0, _moment2.default)(toDate.toDate()).endOf('date'));
      return _collection_utility.CollectionUtility.filter(this.props.dailyPerformanceData, function (performance) {
        return _moment2.default.utc((0, _moment2.default)(performance.date)).isBetween(normalizedFromDate, normalizedToDate, null, '[]');
      });
    }
  }, {
    key: "resetErrorState",
    value: function resetErrorState() {
      if (this.state.error === "extreme") {
        this.props.tooltip.closeTooltip();
        this.setState({
          error: "moderate",
          errorId: null,
          fromDate: !(0, _ramda.isEmpty)(this.state.errorMessage) ? this.state.validFromDate : this.state.fromDate,
          toDate: !(0, _ramda.isEmpty)(this.state.errorMessage) ? this.state.validToDate : this.state.toDate,
          errorMessage: ''
        });
      }
    }
  }, {
    key: "renderDateRangeDropdown",
    value: function renderDateRangeDropdown() {
      return _react2.default.createElement(_date_range_dropdown2.default, {
        dateRangeItems: this.dateRangeItems,
        setRef: this.setRef,
        parentProps: this.props,
        state: this.state
      });
    }
  }, {
    key: "renderCustomDatePickers",
    value: function renderCustomDatePickers() {
      var _this7 = this;

      var dateFormat = "DD/MM/YYYY";
      return _react2.default.createElement(
        "div",
        { className: "display-inline" },
        _react2.default.createElement(
          "div",
          { className: "display-inline-block margin-top-0 margin-right-10 text-top", "data-testid": "from-date-picker" },
          _react2.default.createElement(
            "div",
            {
              className: 'margin-bottom-5 tag-2' + (this.props.breakpoint < 4 ? ' margin-top-5' : '') },
            _string_utility2.default.renderFormattedLabel("FROM", "pdp-perf-chart-date-from-label")
          ),
          _react2.default.createElement(
            "span",
            { className: "font-light caption", style: { 'lineHeight': '1.25' } },
            _react2.default.createElement(
              _click_or_escape_outside2.default,
              {
                id: "from-dropdown",
                ref: "from_dropdown_ref",
                key: "FROM",
                onClose: function onClose() {
                  _this7.resetErrorState();
                }
              },
              _react2.default.createElement(_single_date_picker_wrapper2.default, {
                date: this.state.fromDate,
                minDate: this.minDate,
                maxDate: (0, _moment2.default)(this.maxDate).format("YYYY-MM-DD"),
                onChangeDate: this.onChangeFromDate,
                onFocusChangeCallback: function onFocusChangeCallback() {
                  _this7.setCustomDateRangeDropdown();
                },
                id: this.props.id + "-from-date",
                dateFormat: dateFormat,
                renderMonthElement: this.getMonthAndYearDropdowns()
              })
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "display-inline-block margin-top-0 margin-right-10 text-top", "data-testid": "to-date-picker" },
          _react2.default.createElement(
            "div",
            {
              className: 'margin-bottom-5 tag-2' + (this.props.breakpoint < 4 ? ' margin-top-5' : '') },
            _string_utility2.default.renderFormattedLabel("TO", "pdp-perf-chart-date-to-label")
          ),
          _react2.default.createElement(
            "span",
            { className: "font-light caption", style: { 'lineHeight': '1.25' } },
            _react2.default.createElement(
              _click_or_escape_outside2.default,
              {
                id: "to-dropdown",
                ref: "to_dropdown_ref",
                key: "TO",
                onClose: function onClose() {
                  _this7.resetErrorState();
                }
              },
              _react2.default.createElement(_single_date_picker_wrapper2.default, {
                date: this.state.toDate,
                minDate: (0, _moment2.default)(this.minDate).add(1, 'day').format("YYYY-MM-DD"),
                maxDate: (0, _moment2.default)(this.maxDate).add(1, 'day'),
                onChangeDate: this.onChangeToDate,
                onFocusChangeCallback: function onFocusChangeCallback() {
                  _this7.setCustomDateRangeDropdown();
                },
                id: this.props.id + "-to-date",
                dateFormat: dateFormat,
                renderMonthElement: this.getMonthAndYearDropdowns()
              })
            )
          )
        )
      );
    }
  }, {
    key: "getMonthAndYearDropdowns",
    value: function getMonthAndYearDropdowns() {
      var _this8 = this;

      var years = [];
      for (var i = this.minDate.year(); i <= this.maxDate.year(); i++) {
        years.push(_react2.default.createElement(
          "option",
          { value: i, "data-testId": this.props.id + "-year-dropdown-" + i,
            id: "daily-performance-year-dropdown-" + i },
          i
        ));
      }

      return function (_ref) {
        var month = _ref.month,
            onMonthSelect = _ref.onMonthSelect,
            onYearSelect = _ref.onYearSelect;
        return _react2.default.createElement(
          "div",
          { style: { display: 'flex', justifyContent: 'center' } },
          _react2.default.createElement(
            "div",
            { "data-testId": _this8.props.id + "-month-dropdown", id: "daily-performance-month-dropdown" },
            _react2.default.createElement(
              "select",
              {
                value: month.month(),
                onChange: function onChange(e) {
                  onMonthSelect(month, e.target.value);
                }
              },
              _moment2.default.monthsShort().map(function (label, value) {
                return _react2.default.createElement(
                  "option",
                  {
                    "data-testId": _this8.props.id + "-month-dropdown-" + value,
                    id: "daily-performance-month-dropdown-" + value,
                    value: value },
                  label
                );
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { "data-testId": _this8.props.id + "-year-dropdown", id: "daily-performance-year-dropdown" },
            _react2.default.createElement(
              "select",
              {
                value: month.year(),
                onChange: function onChange(e) {
                  onYearSelect(month, e.target.value);
                }
              },
              years
            )
          )
        );
      };
    }
  }, {
    key: "renderTable",
    value: function renderTable() {
      var _props = this.props,
          fundShareclassPerformanceReturn = _props.fundShareclassPerformanceReturn,
          shortName = _props.shortName,
          country = _props.country,
          role = _props.role,
          visibleData = _props.visibleData;

      return _react2.default.createElement(_daily_performance_table2.default, {
        fundShareclassPerformanceReturn: fundShareclassPerformanceReturn,
        shortName: shortName,
        country: country,
        role: role,
        visibleDataPoints: visibleData.visibleDataPoints
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?type=dailyPerformanceChartCustomSelection' + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale() + '&fromDate=' + getDateFromObject(this.state.dailyPerformanceData[0]) + '&toDate=' + getDateFromObject(this.state.dailyPerformanceData[this.state.dailyPerformanceData.length - 1]));
      var title = _string_utility2.default.getLocalizedString(this.props.intl, "Daily performance", "pdp-daily-performance-chart-header", { role: this.props.role });

      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: "dailyPerformanceChart",
          headerTitle: _string_utility2.default.renderFormattedLabel("Daily performance", "pdp-daily-performance-chart-header"),
          headerTitleId: "DailyPerformanceChartParent",
          headerTitleLabel: "daily-performance-card-header",
          headerLabel: "",
          disclosureText: this.props.disclosure,
          breakpoint: this.props.breakpoint,
          placementId: "pdpCardDailyPerformance",
          showToggleView: this.props.showToggleView,
          toggleAction: function toggleAction(value) {
            return _this9.props.togglePerformanceCard(value);
          },
          toggleActionParameter: 'monthEndReturns',
          activeCardTitle: _string_utility2.default.renderFormattedLabel("Daily Returns", "pdp-performance-daily-return-toggle-label"),
          activeCardId: 'daily-returns',
          inactiveCardTitle: _string_utility2.default.renderFormattedLabel("Month-end Returns", "pdp-performance-month-end-return-toggle-label"),
          inactiveCardId: 'month-end-returns'
        },
        this.renderFilters(),
        this.renderPerformanceChart(),
        this.renderPerformanceChartLegend(),
        this.renderTable(),
        _react2.default.createElement(_button2.default, {
          role: this.props.role,
          dataTest: "download-data",
          downloadURL: excelServiceURL,
          dataTestLink: "performanceChart-excel-download-link",
          text: _string_utility2.default.renderFormattedLabel('DOWNLOAD CHART DATA', 'pdp-download-chart-data', { role: this.props.role }),
          additionalClassName: "mobile-full-width margin-top-30",
          callBack: function callBack() {},
          ariaLabel: "Download Chart Data for " + title
        }),
        !(0, _ramda.isNil)(this.props.largeTextDisclosure) && _react2.default.createElement(
          "div",
          { "data-testid": "pdpCardDailyPerformanceLargeText",
            className: "disclosure display-inline-block font-light disclaimer font-slate-grey",
            style: { width: "100%" } },
          _react2.default.createElement(
            "div",
            {
              className: "caption display-inline-block text-justified position-relative print-hide" },
            _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.largeTextDisclosure) } })
          )
        )
      );
    }
  }, {
    key: "renderFilters",
    value: function renderFilters() {
      return _react2.default.createElement(
        "div",
        { "data-testid": "customDateRangeComponent", className: "font-regular tag" },
        this.renderDateRangeDropdown(),
        this.renderCustomDatePickers()
      );
    }
  }, {
    key: "renderPerformanceChart",
    value: function renderPerformanceChart() {
      var plotPoints = this.getPlotPoints(this.state.dailyPerformanceData);
      var xTicks = (0, _chart_utility.getMonthEndsBetweenDates)(getDateFromObject(plotPoints[0]), getDateFromObject(plotPoints[plotPoints.length - 1]), this.props.breakpoint > 3, false);
      var yTicks = this.getYAxisTicks(plotPoints);
      var IntlPerformanceChartComponent = this.injectComponent;
      return _react2.default.createElement(IntlPerformanceChartComponent, {
        plotPoints: plotPoints,
        yTicks: yTicks,
        xTicks: xTicks,
        breakpoint: this.props.breakpoint,
        numberFormat: this.props.numberFormat,
        visibleDataPoints: (this.props.visibleData || {}).visibleDataPoints,
        formattingRules: (this.props.visibleData || {}).formattingRules,
        fundTypeCode: this.props.fundTypeCode,
        country: this.props.country,
        chartName: "daily performance card"
      });
    }
  }, {
    key: "renderPerformanceChartLegend",
    value: function renderPerformanceChartLegend() {
      return _react2.default.createElement(
        "div",
        { className: "tag chart-legend" },
        (0, _legendCircle.createLegendCircle)("#70C4FF"),
        _react2.default.createElement(
          "span",
          { className: "font-regular display-inline-block", style: { color: "#000000" }, "data-testid": "daily-performance-chart-legend" },
          this.props.shortName
        )
      );
    }
  }]);

  return DailyPerformanceChartParent;
}(_react2.default.Component);

exports.default = DailyPerformanceChartParent;